module.exports = __webpack_public_path__ + "img/prop-bush-4.4ea22738.png";